import { Text } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../../utils/fonts";
import ContainerCards from "../../../../../components/cards";
import { COLORS } from "../../../../../utils/colors";

export const EventPlanDetailsCards = ({
  heading = "",
  body = "",
  mt = "10px",
  bg = COLORS.TRAVEL_PARTNERS_CARD_BGCOLOR,
  width = undefined
}) => {
  return (
    <ContainerCards
      background={bg}
      boxShadow="0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
      height={"auto"}
      width="100%"
    >
      <Text
        fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
        fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
        mt={mt}
        mx={"16px"}
        width={width}
      >
        {heading}
      </Text>
      {body}
    </ContainerCards>
  );
};
